<template>
    <div class="advertiser-container">
        <div>调整处理人</div>
        <el-form label-position="left" inline :model="form" label-width="140px" style="margin-top: 30px;">
            <el-form-item label="工单号">
                <el-input v-model="form.sheetCode" autocomplete="off" placeholder="请输入工单号" @change="changeCode"></el-input>
            </el-form-item>
            <el-form-item label="处理人">
                <el-cascader
                    :options="groupUserList"
                    :props="props"
                    filterable 
                    placeholder="请选择处理人"
                    v-model="form.toUIds"
                    clearable></el-cascader>
            </el-form-item>
            <el-button @click="saveChange" type="primary">提交</el-button>
        </el-form>
  
 
    </div>
  </template>
  
  <script>
  import {getLatestMonthDateArrayByDate} from "@/utils/time";
  import { mapGetters } from "vuex";
  import { getToken } from "@/utils/auth";
  import {encrypt} from "@/utils/encrypt";
  import {UpdateWorkSheetDealUser} from "@/api/workSheet";

  
  export default {
    name: "Advertiser",
    components: { }, 
    computed: { ...mapGetters(['groupUserList','GetWorkSheetDetail_Advance_main','GetWorkSheetDetail_Advance_toUIds']) },
    data() {
      return {        
        form:{
            sheetCode:'',
            toUIds:'',
            wsId:''
        },
        props: { multiple: false },
      };
    },
    async activated() {
        
    },
    async mounted(){
        await this.$store.dispatch('workSheet/groupUserList',{userId:null});
    },
  
    updated(){
      
    },    
  
    watch: {
      
    },
      
    async created() {
            
    },

    methods: {    
        async changeCode(){
            const {sheetCode} = this.form;
            // console.log(sheetCode.trim().length)
            if (sheetCode.trim().length==11){                
                await this.$store.dispatch('workSheet/GetWorkSheetDetail_Advance',{sheetCode}).then(()=>{
                    console.log('this.GetWorkSheetDetail_Advance',this.GetWorkSheetDetail_Advance)
                    this.form.toUIds = this.GetWorkSheetDetail_Advance_toUIds[0].toUIds*1;
                    this.form.wsId = this.GetWorkSheetDetail_Advance_main[0].id;
                });
            }
        },

        async saveChange(){
            const {wsId,toUIds} = this.form;
            var tu = toUIds[0];
            if (!tu){
                tu=toUIds;
            }
            // console.log('this.form',wsId,tu)
            await UpdateWorkSheetDealUser({userId: getToken(),wsId,toUIds:tu}).then(()=>{
                this.$message.success('已提交');
            });
        },
    },
  };
  </script>
  
  <style scoped>
    
  </style>